import type { FormField } from '../../store/slice';
import {
  getEolCustomerNotificationFieldName,
  getEolEffectiveDateFieldName
} from './eolStagesValidation';

/** API keys inside each stage group object (form state still uses long nested field names). */
export const EOL_PAYLOAD_CUSTOMER_NOTIFICATION_DATE_KEY =
  'customerNotificationDate';
export const EOL_PAYLOAD_EFFECTIVE_DATE_KEY = 'effectiveDate';

/** Canonical EOL decommission stage key in create/PATCH payloads (backend @JsonProperty). */
export const EOL_Decommission_PHASE_API_NAME = 'Decommission';

const EOL_Decommission_FORM_GROUP_IDS = new Set([
  'decommission',
  'Decommission'
]);

function resolveEolStageApiKey(group: FormField): string | null {
  if (!group.name) return null;
  if (group.id && EOL_Decommission_FORM_GROUP_IDS.has(group.id)) {
    return EOL_Decommission_PHASE_API_NAME;
  }
  return group.name;
}

/**
 * Maps form nested field names to short API keys under each stage group.
 * Date values (including N/A from `defaultValue`) come from form state via DateComponent.
 */
export function applyEolStagePayloadKeyNames(
  payload: Record<string, unknown>,
  stageGroups: FormField[]
): void {
  stageGroups.forEach(group => {
    const formNotificationKey = getEolCustomerNotificationFieldName(group);
    const formEffectiveKey = getEolEffectiveDateFieldName(group);
    const apiKey = resolveEolStageApiKey(group);
    if (!formNotificationKey || !formEffectiveKey || !apiKey) return;

    const sourceKey =
      group.name && payload[group.name] !== undefined ? group.name : apiKey;
    const current = payload[sourceKey] as Record<string, unknown> | undefined;
    if (!current || typeof current !== 'object') return;

    if (sourceKey !== apiKey) {
      delete payload[sourceKey];
    }

    payload[apiKey] = {
      [EOL_PAYLOAD_CUSTOMER_NOTIFICATION_DATE_KEY]:
        current[formNotificationKey],
      [EOL_PAYLOAD_EFFECTIVE_DATE_KEY]: current[formEffectiveKey]
    };
  });
}
